// Mock data for Vivamore clone (frontend-only)

export const CONTACT = {
  phone: '+60 19-654 7318',
  phoneRaw: '60196547318',
  whatsapp: 'https://wa.me/60196547318',
  whatsappReserve:
    'https://wa.me/60196547318?text=Hi%2C%20I%20would%20like%20to%20make%20a%20reservation',
  email: 'reservation@vivamore.com.my',
  address: 'Level 6, NU Sentral Mall, Kuala Lumpur, Malaysia',
  hours: 'Daily · Lunch & Dinner · 11:00 AM – 10:00 PM',
  instagram: 'https://www.instagram.com/vivamoredining?igsh=MXcxN3B5OG84M3Yyeg%3D%3D&utm_source=qr',
  facebook: 'https://www.facebook.com/profile.php?id=61589483859277',
  tiktok: 'https://www.tiktok.com/@vivamore.dining?_r=1&_t=ZS-965z2Nr7qja'
};

export const IMAGES = {
  heroDining:
    '/interior/fine-dining.webp',
  diningAmbiance:
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nfGVufDB8fHx8MTc4NjE5ODEyN3ww&ixlib=rb-4.1.0&q=85',
  diningInterior:
    '/interior/fine-dining.webp',
  chef:
    'https://images.pexels.com/photos/7627408/pexels-photo-7627408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  privateDining1:
    'https://images.unsplash.com/photo-1768397003905-a202ea6325f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxwcml2YXRlJTIwZGluaW5nfGVufDB8fHx8MTc4NjE5ODEyN3ww&ixlib=rb-4.1.0&q=85',
  privateDining2:
    'https://images.unsplash.com/photo-1673081752959-addbc864f678?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxwcml2YXRlJTIwZGluaW5nfGVufDB8fHx8MTc4NjE5ODEyN3ww&ixlib=rb-4.1.0&q=85',
  wedding1:
    'https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwcmVjZXB0aW9ufGVufDB8fHx8MTc4NjE5ODE1OHww&ixlib=rb-4.1.0&q=85',
  wedding2:
    'https://images.unsplash.com/photo-1583939003579-730e3918a45a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwcmVjZXB0aW9ufGVufDB8fHx8MTc4NjE5ODE1OHww&ixlib=rb-4.1.0&q=85',
  engagement:
    'https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwcmVjZXB0aW9ufGVufDB8fHx8MTc4NjE5ODE1OHww&ixlib=rb-4.1.0&q=85',
  corporate1:
    'https://images.unsplash.com/photo-1700514077430-3659e38eb5e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBnYWxhfGVufDB8fHx8MTc4NjE5ODE1OHww&ixlib=rb-4.1.0&q=85',
  corporate2:
    'https://images.unsplash.com/photo-1653821355736-0c2598d0a63e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBnYWxhfGVufDB8fHx8MTc4NjE5ODE1OHww&ixlib=rb-4.1.0&q=85',
  banquet1:
    'https://images.unsplash.com/photo-1542665952-14513db15293?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxiYW5xdWV0JTIwaGFsbHxlbnwwfHx8fDE3ODYxOTgxNTh8MA&ixlib=rb-4.1.0&q=85',
  banquet2:
    'https://images.unsplash.com/photo-1523438885200-e635ba2c371e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxiYW5xdWV0JTIwaGFsbHxlbnwwfHx8fDE3ODYxOTgxNTh8MA&ixlib=rb-4.1.0&q=85',
  banquet3:
    'https://images.unsplash.com/photo-1568530873454-e4103a0b3c71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxiYW5xdWV0JTIwaGFsbHxlbnwwfHx8fDE3ODYxOTgxNTh8MA&ixlib=rb-4.1.0&q=85',
  foodPasta1: 'https://images.unsplash.com/photo-1516100882582-96c3a05fe590?q=80&w=1200&auto=format&fit=crop',
  foodPasta2: 'https://images.unsplash.com/photo-1627042633145-b780d842ba45?q=80&w=1200&auto=format&fit=crop',
  foodBurger1: 'https://images.pexels.com/photos/15010285/pexels-photo-15010285.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  foodBurger2: 'https://images.unsplash.com/photo-1550547660-d9450f859349?q=80&w=1200&auto=format&fit=crop',
  foodVeg: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?q=80&w=1200&auto=format&fit=crop',
  foodDessert: 'https://images.unsplash.com/photo-1637944220604-c5f28faac604?q=80&w=1200&auto=format&fit=crop'
};

export const EXPERIENCES = [
  {
    title: 'Dining',
    desc: 'Exquisite culinary creations in an elegant atmosphere',
    img: IMAGES.diningAmbiance,
    link: '/dining'
  },
  {
    title: 'Weddings',
    desc: 'Create your perfect day with our bespoke wedding services',
    img: IMAGES.wedding1,
    link: '/events'
  },
  {
    title: 'Corporate',
    desc: 'Professional spaces for meetings and corporate events',
    img: IMAGES.corporate1,
    link: '/events'
  }
];

export const TESTIMONIALS = [
  {
    quote:
      'Beautiful venue and amazing food. Our wedding at Vivamore was absolutely magical. The team went above and beyond to make our special day perfect.',
    name: 'Sarah & Ahmad',
    role: 'Wedding Clients'
  },
  {
    quote:
      'Seamless corporate event experience. The facilities are top-notch and the catering exceeded our expectations. Will definitely return for future events.',
    name: 'James Wong',
    role: 'Corporate Client'
  },
  {
    quote:
      'The attention to detail is remarkable. From the elegant decor to the exquisite cuisine, every aspect of our anniversary dinner was flawless.',
    name: 'The Lim Family',
    role: 'Private Dining'
  },
  {
    quote:
      'Professional service and stunning ambiance. Our engagement ceremony was everything we dreamed of and more.',
    name: 'Nurul & Farhan',
    role: 'Engagement Ceremony'
  }
];

export const PHILOSOPHY = [
  {
    title: 'Convenient',
    desc: 'Centrally located at NU Mall Kuala Lumpur with seamless accessibility, modern facilities, and a welcoming atmosphere designed for effortless experiences.'
  },
  {
    title: 'Connect',
    desc: 'A thoughtfully designed space where conversations, relationships, business interactions, and meaningful moments come together naturally.'
  },
  {
    title: 'Celebrate',
    desc: 'From intimate gatherings to milestone celebrations, Vivamore creates contemporary experiences that turn every occasion into a memorable one.'
  }
];

export const VENUE_FEATURES = [
  'Contemporary and elegant event space',
  'Ideal for corporate events and social gatherings',
  'Suitable for intimate weddings and receptions',
  'Flexible setup arrangements',
  'Premium dining and various buffet options',
  'Conveniently located at NU Mall Kuala Lumpur',
  'Dedicated hospitality and event support team',
  'Comfortable venue capacity for up to 120 guests'
];

export const COMMITMENTS = [
  'Sourcing only the finest ingredients from trusted suppliers',
  'Maintaining the highest standards of hygiene and safety',
  'Continuous training for our staff in hospitality excellence',
  'Sustainable practices in our operations'
];

export const MENU = {
  Pasta: [
    { name: 'Chicken Aglio Olio', desc: 'Spaghetti with garlic, olive oil, chili flakes, Cajun chicken, peppers & cherry tomatoes. Served with parmesan & garlic toast.', price: 'RM 23', img: IMAGES.foodPasta1 },
    { name: 'Marinara Meatball Spaghetti', desc: 'Spaghetti with braised meatballs in tomato sauce, bell peppers. Served with parmesan & garlic toast.', price: 'RM 23', img: IMAGES.foodPasta2 },
    { name: 'Carbonara Chicken Spaghetti', desc: 'Creamy spaghetti with chicken slices. Served with parmesan & garlic toast.', price: 'RM 23', img: IMAGES.foodPasta1 },
    { name: 'Seafood Arrabbiata Spaghetti', desc: 'Spicy tomato spaghetti with shrimp & squid. Served with parmesan & garlic toast.', price: 'RM 24', img: IMAGES.foodPasta2 }
  ],
  Burger: [
    { name: 'Classic Beef Burger', desc: 'Juicy beef patty, cheddar, lettuce, tomato & house sauce. Served with fries.', price: 'RM 25', img: IMAGES.foodBurger1 },
    { name: 'Crispy Chicken Burger', desc: 'Buttermilk fried chicken, coleslaw & spicy mayo. Served with fries.', price: 'RM 23', img: IMAGES.foodBurger2 },
    { name: 'Double Cheese Burger', desc: 'Two beef patties, double cheddar, caramelised onions. Served with fries.', price: 'RM 29', img: IMAGES.foodBurger1 },
    { name: 'Mushroom Swiss Burger', desc: 'Beef patty, sautéed mushrooms & swiss cheese. Served with fries.', price: 'RM 27', img: IMAGES.foodBurger2 }
  ],
  Vegetarian: [
    { name: 'Garden Fresh Salad', desc: 'Mixed greens, cherry tomatoes, cucumber & house vinaigrette.', price: 'RM 18', img: IMAGES.foodVeg },
    { name: 'Aglio Olio Vegetariano', desc: 'Spaghetti with garlic, olive oil, chili flakes & seasonal vegetables.', price: 'RM 20', img: IMAGES.foodVeg },
    { name: 'Mushroom Truffle Pasta', desc: 'Creamy pasta with mushrooms & a hint of truffle oil.', price: 'RM 24', img: IMAGES.foodVeg },
    { name: 'Grilled Vegetable Platter', desc: 'Seasonal grilled vegetables with balsamic glaze.', price: 'RM 22', img: IMAGES.foodVeg }
  ],
  Desserts: [
    { name: 'Classic Tiramisu', desc: 'Espresso-soaked sponge with mascarpone cream & cocoa.', price: 'RM 16', img: IMAGES.foodDessert },
    { name: 'Molten Chocolate Cake', desc: 'Warm chocolate cake with a molten centre & vanilla ice cream.', price: 'RM 17', img: IMAGES.foodDessert },
    { name: 'New York Cheesecake', desc: 'Rich baked cheesecake with berry compote.', price: 'RM 16', img: IMAGES.foodDessert },
    { name: 'Crème Brûlée', desc: 'Silky vanilla custard with a caramelised sugar crust.', price: 'RM 15', img: IMAGES.foodDessert }
  ]
};

export const EVENT_SOLUTIONS = {
  'Weddings & Celebrations': [
    { title: 'Intimate Wedding', desc: 'Traditional ceremonies with modern elegance', img: IMAGES.wedding1, features: ['Pelamin setup', '50-100 guests', 'Full catering', 'Decoration'] },
    { title: 'Engagement', desc: 'Intimate celebrations for your special moment', img: IMAGES.engagement, features: ['Customizable setup', '50-100 guests', 'Buffet dining'] },
    { title: 'Private Events', desc: 'Bespoke celebrations tailored to you', img: IMAGES.wedding2, features: ['Flexible arrangements', '50-100 guests', 'Custom menus', 'Full support'] }
  ],
  'Corporate Events': [
    { title: 'Corporate Gala', desc: 'Sophisticated evenings for milestone moments', img: IMAGES.corporate1, features: ['Stage & AV setup', 'Up to 120 guests', 'Plated or buffet dining', 'Dedicated coordinator'] },
    { title: 'Annual Dinner', desc: 'Celebrate your team in refined surroundings', img: IMAGES.corporate2, features: ['Custom theming', 'Up to 120 guests', 'Awards setup', 'Full catering'] },
    { title: 'Meetings & Seminars', desc: 'Professional spaces for productive gatherings', img: IMAGES.banquet1, features: ['Flexible layouts', 'AV & projector', 'Coffee breaks', 'Business lunch'] }
  ]
};

export const WEDDING_SERVICES = [
  { title: 'Pelamin Setup', desc: 'Elegant bridal dais with traditional or modern designs' },
  { title: 'Seating Layout', desc: 'Flexible arrangements for up to 100 guests' },
  { title: 'Catering', desc: 'Exquisite buffet options for every palate' },
  { title: 'Photography', desc: 'Beautiful backdrops and photo opportunities' }
];

export const WHY_VIVAMORE = [
  'Central location with ample parking',
  'Dedicated event coordinator',
  'Customizable packages to suit your needs',
  'Premium buffet catering with diverse menu options'
];

// Real Vivamore venue photos (served from /public/gallery)
export const REAL_PHOTOS = {
  interior: '/interior/fine-dining.webp',
  tableSetting: '/gallery/event1.jpeg',
  banquetHall: '/gallery/event2.webp',
  weddingSign: '/gallery/event3.webp',
  groupDinner: '/gallery/event4.webp',
  buffet: '/gallery/event5.webp',
  mocktailGlasses: '/gallery/ladies.webp',
  groupCelebration: '/gallery/mocktails.webp',
  rendang: '/gallery/rendang.webp',
  setupEvening: '/gallery/setup-evening.webp'
};

export const GALLERY = [
  { img: REAL_PHOTOS.interior, cat: 'Venue' },
  { img: REAL_PHOTOS.mocktailGlasses, cat: 'Weddings' },
  { img: REAL_PHOTOS.setupEvening, cat: 'Venue' },
  { img: REAL_PHOTOS.rendang, cat: 'Dining' },
  { img: REAL_PHOTOS.groupCelebration, cat: 'Events' },
  { img: REAL_PHOTOS.mocktailGlasses, cat: 'Dining' },
  { img: REAL_PHOTOS.groupDinner, cat: 'Events' },
  { img: REAL_PHOTOS.tableSetting, cat: 'Dining' },
  { img: REAL_PHOTOS.weddingSign, cat: 'Weddings' },
  { img: REAL_PHOTOS.banquetHall, cat: 'Venue' },
  { img: REAL_PHOTOS.buffet, cat: 'Dining' },
  { img: IMAGES.corporate1, cat: 'Corporate' },
  { img: IMAGES.banquet1, cat: 'Venue' },
  { img: IMAGES.engagement, cat: 'Weddings' },
  { img: IMAGES.corporate2, cat: 'Corporate' },
  { img: IMAGES.banquet2, cat: 'Venue' },
  { img: IMAGES.wedding2, cat: 'Weddings' }
];

export const EVENT_TYPES = ['Wedding Reception', 'Engagement Ceremony', 'Corporate Event', 'Annual Dinner', 'Birthday Party', 'Anniversary', 'Other'];
export const GUEST_COUNTS = ['20 - 50 guests', '50 - 100 guests', '100 - 200 guests', '200 - 300 guests', '300+ guests'];
export const BUDGETS = ['Below RM 10,000', 'RM 10,000 - RM 30,000', 'RM 30,000 - RM 50,000', 'RM 50,000 - RM 100,000', 'Above RM 100,000'];
